import React, { useContext, useEffect, useState } from "react";
import NotificationBar from "../../notification-bar";
import { ProductsContext } from "contexts/attributes";
import { useProductValidation } from "shared/hooks/use-product-validation";
import eventEmitter from "shared/events";

const AttributeErrors = ({ codingWipKey, definitions, showValidation = true }) => {
    const [attributeErrors, setAttributeErrors] = useState([]);
    const { products } = useContext(ProductsContext);
    const validateFields = useProductValidation(products);

    useEffect(() => {
        const newAttributeErrors =
            products[codingWipKey].length === 0
                ? [{ name: "More than 1 attribute is required", errors: [] }]
                : validateFields(definitions, codingWipKey);

        setAttributeErrors(newAttributeErrors);
        eventEmitter.emit("PRODUCTS_VALIDITY", codingWipKey, newAttributeErrors.length === 0);
    }, [definitions, products]);

    const errorBody = attributeErrors.map((e, index) => {
        return <li key={`error_${index}`}>{e}</li>;
    });

    return showValidation && attributeErrors.length > 0 ? (
        <NotificationBar type="error">
            <ul>{errorBody}</ul>
        </NotificationBar>
    ) : null;
};

export default AttributeErrors;
